export const defaultValues = {
    "freq": "",
    "agc": "off",
    "amplitude": "no",
    "normalise": "yes",
    "functional": "2NRM",
}


// WEBPACK FOOTER //
// ./src/app/shared/default_value/default_value.ts